import { handleRequest } from "../utilities/requestHandler";

export const searchProducts = (req_body) => 
    handleRequest("post", "/products/search", req_body);